// Spec 078 — o read model da cena (research R7): polling de 5 s enquanto a aba está visível
// (o movimento da vazão não emite WS) + invalidação de ["scene", lineId] pelos eventos existentes.
import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import { SCENE_POLL_MS } from "@opus-dt/shared-types";
import { api } from "@/lib/api-client";
import type { LineSceneResponse } from "@/types/scene.types";

export const sceneQueryKey = (lineId: string) => ["scene", lineId] as const;

export interface UseLineSceneOptions {
  enabled?: boolean;
  pollMs?: number;
}

export function useLineScene(
  lineId: string,
  opts: UseLineSceneOptions = {}
): UseQueryResult<LineSceneResponse> {
  return useQuery({
    queryKey: sceneQueryKey(lineId),
    queryFn: () => api.get<LineSceneResponse>(`/api/v1/lines/${lineId}/scene`),
    enabled: (opts.enabled ?? true) && lineId.length > 0,
    refetchInterval: opts.pollMs ?? SCENE_POLL_MS,
    refetchIntervalInBackground: false,
    // A cena vive de atualização: dado antigo continua desenhado enquanto o novo chega.
    placeholderData: (prev) => prev,
  });
}
